var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29864 9.57519C3.23741 10.7385 3.3078 11.9768 2.26844 12.7563C1.7847 13.1192 1.5 13.6886 1.5 14.2932C1.5 15.125 2.1515 15.8327 3 15.8327H15C15.8485 15.8327 16.5 15.125 16.5 14.2932C16.5 13.6886 16.2153 13.1192 15.7316 12.7563C14.6922 11.9768 14.7626 10.7385 14.7014 9.5752C14.5418 6.54287 12.0365 4.16602 9 4.16602C5.96348 4.16602 3.45824 6.54287 3.29864 9.57519Z",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.60352C7.75 3.29387 8.30964 4.16602 9 4.16602C9.69036 4.16602 10.25 3.29387 10.25 2.60352C10.25 1.91316 9.69036 1.66602 9 1.66602C8.30964 1.66602 7.75 1.91316 7.75 2.60352Z",
    stroke: "#14181F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.832C11.5 17.2127 10.3807 18.332 9 18.332C7.61929 18.332 6.5 17.2127 6.5 15.832",
    stroke: "#14181F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.bcae53f622409b903d9290c3375015c5.svg";
export { ForwardRef as ReactComponent };